module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-modal"
  }, [_c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.close
    }
  }), _c('a', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }), _c('section', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.productModal.url
    }
  })]), _c('div', {
    staticClass: "modal-content"
  }, [_c('h2', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.productModal.name))]), _c('h4', {
    staticClass: "product-author"
  }, [_vm._v(_vm._s(_vm.productModal.author))]), _c('div', {
    staticClass: "product-info"
  }, [_c('span', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm.productModal.price))])]), _vm._m(0), _c('div', {
    staticClass: "product-cart"
  }, [_c('a', {
    staticClass: "input-btn"
  }, [_vm._v("Add to Card")]), _c('ul', {
    staticClass: "product-social"
  }, _vm._l((_vm.socials), function(social) {
    return _c('li', {
      staticClass: "social-item"
    }, [_c('a', {
      staticClass: "social-link"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/icons/" + social + ".svg")
      }
    })])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-about"
  }, [_c('p', {
    staticClass: "about-text"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do\neiusmod tempor incididunt ut labore et dolore magna aliqua.\nUt enim ad minim veniam, quis nostrud exercitation ullamco\nlaboris nisi ut aliquip ex ea commodo consequat.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3ab554b9"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Product.vue
// module id = 126
// module chunks = 0